module.exports = __webpack_public_path__ + "static/media/bg-leaf.9450f76f.svg";